export const lv = {
  general: {
    home: "Sākums",
    yes: "Jā",
    no: "Nē",
    title: "Arbor servisa portāls",
    login: "Pieslēgties",
    logout: "Iziet",
    profile: "Profils",
  },
  register: {
    title: "Reģistri",
    equipment: {
      title: "Iekārtas",
      labels: {
        model: "Modelis",
        clientInventoryNumber: "Klienta inventāra Nr.",
        installationDate: "Instalācijas datums",
        serviceProjectNumber: "Servisa projekta Nr.",
        serviceContractNumber: "Servisa līguma Nr.",
        projectCode: "Projekta kods",
        saleContractNumber: "Pārdošanas līguma Nr.",
        saleDocumentNumber: "Pārdošanas dokumenta Nr.",
        saleContractFile: "Pārdošanas līguma fails",
        deviceData: "Iekārtas dati",
        componentData: "Komponentes dati",
        clientData: "Klienta dati",
        manufacturerData: "Ražotāja dati",
        serviceContractFile: "Servisa līguma fails",
        manufacturerWarrantyExpirationDate: "Ražotāja garantijas termiņš",
        manufacturerSupportExpirationDate: "Ražotāja atbalsta termiņš",
        warrantyExpirationDate: "Garantijas termiņš (Arbor)",
        devicePackage: "Iekārtas komplektācija",
        installations: "Instalācijas",
        acquisitionDocumentNumber: "Ražotāja PPZ Nr.",
        acquisitionDocumentFile: "Ražotāja PPZ fails",
        acquisitionDocumentDate: "Ražotāja PPZ datums",
        orderNumber: "Pasūtījuma Nr.",
        department: "Nodaļa",
      },
      errors: {
        installationDateValidationMessage: "Šis lauks ir obligāts! Datumiem jābūt augošā secībā!",
        equipmentStateValidationMessage: "Instalāciju statusi nevar atkārtoties! Pēc norakstīšanas instalācijas nav iespējamas!",
      },
      messages: {
        confirmSaveDeletePackage: "Deinstalējot iekārtu kurai ir piesaistītas komponentes, tās tiks deinstalētas ar tādu pašu datumu. Turpināt?",
        confirmSaveComponentDatesInvalid: "Iekārtas komplektācijā ir komponentes ar instalāciju datumiem, kuri nav saderīgi ar iekārtas deinstalācijas datumu! Deinstalējot iekārtu, kurai ir piesaistītas komponentes, tās tiks deinstalētas ar tādu pašu datumu. Turpināt?",
        confirmCopyInstallations: "Kopēt ievadītās instalācijas visām iekārtām?",
        noEquipmentSelected: "Iekārta nav izvēlēta!",
      },
      actions:{
        copyInstallations: "Kopēt instalācijas",
      }
    },
    component: {
      title: "Komponentes",
      labels: {
        chooseDevice: "Izvēlies iekārtu",
        deviceData: "Iekārtas dati",
      },
      messages:{
        confirmCopyInstallations: "Kopēt ievadītās instalācijas visām komponentēm?",
      }
    },
    serviceAct: {
      title: "Servisa akti",
      labels: {
        saveAsDraft: "Saglabāt kā melnrakstu",
        branch: "Filiāle",
        department: "Nodaļa",
        callNumber: "Izsaukuma nr.",
        dateTimeArrival: "Ierašanās datums/laiks",
        dateTimeDeparture: "Aizbraukšanas datums/laiks",
        workIsCompleted: "Darbs pabeigts",
        workNotCompleted: "Darbs nav pabeigts",
        complaint: "Sūdzība",
        workDone: "Veiktie darbi",
        timeSpent: "Patērētais laiks",
        DIAGNOSTICS: "Diagnostika",
        FUNCTIONAL_ELECTRICAL_TEST: "Funkc. el. drošības pārbaude",
        INSTALLATION: "Instalācija",
        REPAIRS: "Remonts",
        PROFILACTIC_MAINTENANCE: "Profilaktiskā apkope",
        TRAINING: "Apmācības",
        TRAVELLING: "Ceļā pavadītais laiks",
        clientApproval: "Klienta apstiprinājums",
        serviceActPrintout: "Servisa akta izdruka",
        actInformation: "Akta informācija",
        chooseEngineer: "Izvēlies inženieri",
        usedPartsAndInstruments: "Izmantotās rezerves daļas un mērierīces",
        neededPartsAndInstruments: "Nepieciešamās rezerves daļas un mērierīces",
        contractNumber: "Līguma Nr.",
        conclusionRemarks: "Slēdziens/piezīmes",
        signature: "Paraksts",
        engineers: "Inženieri",
        sendForApproval: "Nosūtīt apstiprināšanai",
        sentForApproval: "Nosūtīts apstiprināšanai",
        addSignature: "Pievienot parakstu",
      },
      actions: {
        addSignature: "Pievienot parakstu",
        deleteSignature: "Dzēst parakstu",
        confirmDeleteSignature: "Vai tiešām vēlaties dzēst parakstu?",
        saveWorkCompleted: "Saglabāt (Darbs pabeigts)",
        saveWorkNotCompleted: "Saglabāt (Darbs nav pabeigts)",
        saveDraft: "Saglabāt kā melnrakstu"
      },
      messages: {
        serviceActApprovalSentSuccessfully: "Servisa akts veiksmīgi nosūtīts apstiprināšanai!",
        isWorkCompleted: "Vai darbs ir pabeigts?"
      }
    },
    serviceActApproval: {
      labels: {
        serviceActRating: "Servisa akta novērtējums",
        approveDate: "Apstiprināšanas/noraidīšanas datums",
        expireDateTime: "Derīgs līdz",
      },
      actions: {
        approve: "Apstiprināt",
        deny: "Noraidīt",
        send: "Nosūtīt",
        resend: "Nosūtīt atkārtoti",
      },
      messages: {
        confirmApprove: "Vai tiešām vēlaties apstiprināt servisa aktu?",
        confirmDeny: "Vai tiešām vēlaties noraidīt servisa aktu?",
      }
    },
    call: {
      title: "Zvanu reģistrs",
      labels: {
        chooseDevice: "Izvēlēties iekārtu",
        addComponent: "Pievienot komponenti",
        issue: "Problēma",
        callNotificationType: "Paziņojuma veids",
        completed: "Izpildīts/atteikts",
        serviceActs: "Servisa akti",
        costs: "Izmaksas",
        invoiceNumber: "Rēķina Nr.",
      },
      actions: {
        createServiceAct: "Izveidot servisa aktu"
      },
      messages: {
        copiedToClipboard: "Izsaukums veiksmīgi kopēts starpliktuvē!"
      }
    },
    maintenance: {
      title: "Apkopes",
      labels: {
        serviceAct: "Servisa akts",
        maintenanceType: "Apkopes veids",
        chooseEquipment: "Izvēlēties iekārtu/komponenti",
        maintenanceRequest: "Apkopes pieteikums",
        warranty: "Garantija",
      }
    },
    maintenanceCycle: {
      title: "Apkopju cikli",
      labels: {
        lastDoneDate: "Pēdējoreiz veikta",
        plannedDate: "Plānota",
        maintenanceCount: "Veikto apkopju skaits",
        period: "Periods (mēneši)",
        countPeriodFromPlannedDate: "Skaitīt datumu no pirmās apkopes"
      },
      actions: {
        addMaintenance: "Pievienot apkopi",
      },
      errors: {
        periodInvalid: "Periodam jābūt veselam skaitlim kurš lielāks kā 0!"
      }
    },
    maintenanceRequest: {
      title: "Apkopju pieteikumi",
      labels: {

      }
    }
  },
  classifier: {
    title: "Klasifikatori",
    equipmentmodel: {
      title: "Iekārtu modeļi",
    },
    equipmenttype: {
      title: "Iekārtu veidi",
    },
    equipmentcategory: {
      title: "Iekārtu kategorijas",
    },
    manufacturer: {
      title: "Ražotāji",
      labels: {
        manufacturer: "Ražotājs",
      },
    },
    client: {
      title: "Klienti",
      labels: {
        client: "Klients",
      }
    },
    enduser: {
      title: "Gala lietotāji",
    },
    profession: {
      title: "Profesijas",
    },
    person: {
      title: "Personas",
      labels: {
        firstName: "Vārds",
        lastName: "Uzvārds",
        phone: "Telefona numurs",
        email: "E-pasts",
        profession: "Profesija",
      }
    },
    template:{
      labels: {
        sharedTemplate: "Koplietojams šablons",
      }
    }
  },
  administration: {
    title: "Administrācija",
    administration: {
      title: "Administrācija",
      labels: {
        passwordCurrent: "Pašreizējā parole",
        passwordNew: "Jaunā parole",
        passwordConfirm: "Parole atkārtoti",
        changePassword: "Mainīt paroli",
        users: "Lietotāji",
        userData: "Lietotāja dati",
        userPermissions: "Lietotāja tiesības",
        userRoles: "Lietotāja lomas",
        role: "Loma",
        roles: "Lomas",
        rolePermissions: "Lomas tiesības",
      },
    },
    printForm: {
      title: "Izdrukas",
      labels: {
        parameters: "Parametri",
        settings: "Izdrukas iestatījumi",
        exportFormat: "Formāts"
      },
      actions: {
        generatePreview: "Skatīt priekšskatījumu",
      }
    },
    report: {
      title: "Pārskati",
    }
  },
  common: {
    labels: {
      code: "Kods",
      name: "Nosaukums",
      type: "Veids",
      serialNumber: "Sērijas Nr.",
      client: "Klients",
      endUser: "Gala lietotājs",
      state: "Statuss",
      comments: "Komentāri",
      refNumber: "References Nr.",
      active: "Aktīvs",
      created: "Izveidots",
      category: "Kategorija",
      date: "Datums",
      attachments: "Pielikumi",
      attachmentsDrop: "vai nometiet failus šeit",
      file: "Fails",
      fileName: "Faila nosaukums",
      user: "Lietotājs",
      number: "Numurs",
      status: "Statuss",
      baseInformation: "Pamatinformācija",
      engineers: "Inženieri",
      engineer: "Inženieris",
      department: "Nodaļa",
      contractNumber: "Līguma Nr.",
      devices: "Iekārtas",
      components: "Komponentes",
      minutes: "Minūtes",
      quantity: "Daudzums",
      manufacturer: "Ražotājs",
      device: "Iekārta",
      component: "Komponente",
      model: "Modelis",
      clientInventoryNumber: "Klienta inventāra Nr.",
      contact: "Kontakts",
      contacts: "Kontakti",
      contactInformation: "Kontaktinformācija",
      id: "Id",
      warranty: "Garantija",
      equipment: "Iekārta/komponente",
      dateTime: "Datums/Laiks",
      nameSurname: "Vārds, Uzvārds",
      preview: "Priekšskatījums",
      email: "E-pasts",
      isActive: "Aktīvs",
      templates: "Šabloni",
      editTemplate: "Rediģēt šablonu",
      content: "Saturs",
      person: "Persona",
      userName: "Lietotājvārds",
      password: "Parole",
      count: "Skaits",
      group: "Grupa",
      columnChooser: "Kolonnu redaktors",
    },
    actions: {
      save: "Saglabāt",
      submit: "Iesniegt",
      delete: "Dzēst",
      back: "Atpakaļ",
      search: "Meklēt",
      new: "Jauns",
      browse: "Pārlūkot",
      download: "Lejupielādēt",
      copyToClipboard: "Kopēt starpliktuvē",
      createMaintenance: "Izveidot apkopi",
      createMaintenanceCycle: "Izveidot apkopes ciklu",
      createMaintenanceRequest: "Izveidot apkopes pieteikumu",
      createCall: "Izveidot izsaukumu",
      createServiceAct: "Izveidot servisa aktu",
      add: "Pievienot",
      edit: "Rediģēt",
      create: "Izveidot",
      apply: "Lietot",
      cancel: "Atcelt",
      chooseDevice: "Izvēlēties iekārtu",
      chooseComponent: "Izvēlēties komponenti",
      copy: "Kopēt",
      import: "Importēt",
      export: "Eksportēt",
      clearFilters: "Notīrīt filtrus",
    },
    messages: {
      saved: "Saglabāts",
      confirmDelete: "Ieraksts tiks dzēsts. Turpināt?",
      deleted: "Dzēsts",
      noData: "Nav ierakstu",
    },
    errors: {
      valueEmpty: "Šis lauks obligāti jānorāda!",
      requiredFieldsEmpty: "Visi obligātie lauki nav aizpildīti!",
      dateInvalid: "Ievadītā vērtība neatbilst datuma/laika formātam!",
      dateTimeInvalid: "Ievadītā vērtība neatbilst datuma/laika formātam!"
    }
  },
  errors: {
    api: {
      //GLOBAL
      INTERNAL_SERVER_ERROR: "Servera kļūda",
      VALUE_EXISTS: "Vērtība '{p}' jau eksistē",
      USER_NAME_EMPTY: "Jānorāda lietotājvārds",
      USER_NAME_EXISTS: "Lietotājvārds eksistē",
      USER_DISPLAY_NAME_EMPTY: "Jānorāda nosaukums",
      PASSWORD_EMPTY: "Jānorāda parole",
      PASSWORD_INVALID: "Nepareiza parole",
      CONFIRM_PASSWORD_EMPTY: "Jānorāda parole atkārtoti",
      PASSWORD_MISMATCH: "Paroles nesakrīt",
      VALUE_EMPTY: "Vērtība '{p}' obligāti jānorāda!",
      VALUE_INVALID: "Laukā '{p}' ievadīta nekorekta vērtība!",
      OBJECT_USED_BY_ANOTHER_OBJECT: "Šis objekts ir piesaistīts citam objektam!",
      undefined: "Notika kļūda",
      //ServiceAct
      DEPARTURE_TIME_MUST_EXCEED_ARRIVAL_TIME: "Ierašanās laiks nedrīkst pārsniegt aizbraukšanas laiku!",
      //Equipment
      COMPONENT_INSTALLED_AFTER_EQUIPMENT_DEINSTALLATION_DATE: "Komponentes instalācijas datums ir vēlāks nekā iekārtas iestatītais deinstalācijas datums!"
    },
    auth: {
      incorrectCredentials: "Nepareizs lietotājvārds/parole"
    }
  },
};
